import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const StyledModal = styled(Modal)`
    position: absolute;    
    background-color: ${props => props.theme.ecoMint};
    top: 25vh;
    left: 25vw;
    width: 50vw;
    border-radius: 8px;
    z-index: 10000;
    padding: 1%;

    @media only screen and (max-width: 600px) {
        width: 90%;
        left: 2vw;
        padding: 5%;
        font-size: 1rem;
    }
`;
export const InnerModal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export const StyledModalHeader = styled(Modal.Header)`
    color: ${props => props.theme.voltBlue};
    border-radius: 8px;
    width: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    text-align: center;
    align-self: center;
`;

export const CloseButton = styled.button`
    color: ${props => props.theme.voltBlue};
    background-color: transparent;
    border: none;
    cursor: pointer;
    align-self: right;
    font-size: 2rem;
`;

export const BlockBackground = styled.div`
    position: absolute;
    width: 100vw;
    height: 500vh;
    top: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 100;
    display: ${props => props.show ? 'block' : 'none'};
`;